import { Line3 as o } from "three";
import { LineV3toLine3 as n } from "../index2.js";
import { sortAlignedPoints as i } from "./index24.js";
function d(t, r) {
  t = n(t), r = n(r);
  const e = i([t.start, t.end, r.start, r.end]);
  return new o(e[1], e[2]);
}
export {
  d as getOverlapLine
};
//# sourceMappingURL=index12.js.map
